import { useEffect, useRef } from 'react';

import { MIN_BALANCE } from 'utils/constants/app';

import Loading, { LoadingScale } from 'bloko/blocks/loading';
import VSpacing from 'bloko/blocks/vSpacing';
import cookies from 'bloko/common/Cookies';

import useTrls from 'hooks/translation/useTrls';

import CampaignCard from 'components/CampaignCard/CampaignCard';
import { fetchCampaignsNextPage } from 'components/Dashboard/CampaignList/fetchCampaignsNextPage';
import useHasAppliedFilters from 'components/Dashboard/Filters/useHasAppliedFilters';

import { setShowLowBalanceInfo } from 'store/autoReducers';
import { CampaignLoadState, CampaignTabStatus } from 'store/models/dashboard';
import { useDispatch, useSelector } from 'store/utils';

const cookieName = 'minBalance';
const html = document.querySelector('html');

const TrlKeys = {
    searchOrFilterNoResult: 'Dashboard.CampaignList.searchOrFilterNoResults',
    campaignsNoResultActive: 'Dashboard.CampaignList.noResults.Active',
    campaignsNoResultOff: 'Dashboard.CampaignList.noResults.Off',
};

const CampaignList = () => {
    const campaignTabsStatus = useSelector((state) => state.campaignTabsStatus);
    const { campaigns, isLoad } = useSelector((state) => state.dashboard);
    const isCampaignSearchUploaded = useSelector((state) => state.dashboard.isCampaignSearchUploaded);
    const { balance, realBalance } = useSelector((state) => state.balance);
    const currentStatus = useSelector((state) => state.campaignTabsStatus);
    const maxBannersInCampaign = useSelector((state) => state.clickme.maxBannersInCampaign);
    const counts = useSelector((state) => state.countsCampaign);
    const hasAppliedFilters = useHasAppliedFilters();

    const trl = useTrls();
    const dispatch = useDispatch();

    const campaignsList = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (campaignsList.current && html.scrollTop + html.clientHeight >= campaignsList.current.scrollHeight) {
                dispatch(fetchCampaignsNextPage({ currentStatus }));
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [campaignsList, currentStatus, dispatch]);

    useEffect(() => {
        const minBalance = cookies.get(cookieName);
        const haveActiveCampaign = counts[CampaignTabStatus.Active] > 0;
        if (balance <= MIN_BALANCE && !minBalance && haveActiveCampaign) {
            cookies.set(cookieName, 'true', 24);
            dispatch(setShowLowBalanceInfo(true));
        }
    }, [balance, counts, dispatch]);

    if (campaigns.length === 0) {
        if (isCampaignSearchUploaded || hasAppliedFilters) {
            return (
                <div data-qa="search-no-result-text">
                    <VSpacing base={6} />
                    {trl(TrlKeys.searchOrFilterNoResult)}
                </div>
            );
        }
        if (isLoad === CampaignLoadState.Loading) {
            return <Loading scale={LoadingScale.Small} />;
        }
        return (
            <div data-qa={`campaigns-no-result-text-${currentStatus}`}>
                <VSpacing base={6} />
                {trl(
                    currentStatus === CampaignTabStatus.Active
                        ? TrlKeys.campaignsNoResultActive
                        : TrlKeys.campaignsNoResultOff
                )}
            </div>
        );
    }

    return (
        <div ref={campaignsList} className="clickme-campaigns">
            {(campaigns.length === 0 || campaignTabsStatus === CampaignTabStatus.Off) && <VSpacing base={6} />}
            {campaigns.map((campaign) => (
                <CampaignCard
                    key={campaign.id}
                    campaign={campaign}
                    userBalance={balance}
                    realBalance={realBalance}
                    maxBannersInCampaign={maxBannersInCampaign}
                />
            ))}
            {isLoad === CampaignLoadState.Loading ? <Loading scale={LoadingScale.Small} /> : null}
        </div>
    );
};

export default CampaignList;
